import React from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie'
import { getCustomFieldConfig } from '../../utils/propConfigHelper'

// 常量
import Constants from '../utils/constantsForDmpChart'

// 实用方法
import Utils from '../utils/utilsForDmpChart'

// 属性基础组件
import PropComponents from './propComponents/index'

// 通用基础组件
import EmptyTip from '@components/EmptyStatus'
import * as Notification from '@components/notification'
import { Form, ValidatedInput } from '@components/bootstrap-validation'
import ChartLoading from '../../kernel/components/ChartLoading'

const BaseComponents = {
  EmptyTip,
  Form,
  ValidatedInput,
  ChartLoading,
  Notification
}

// 高阶组件Connect
const Connect = chartsdkprops => (ChartComponent) => {
  const chartName = ChartComponent.displayName || ChartComponent.name || 'ChartComponent'
  return class extends React.Component {
    static displayName = `DmpChartDev(${chartName})`

    static propTypes = {
      appContext: PropTypes.string,
      chartData: PropTypes.object,
      dashboardChartData: PropTypes.object,
      designTime: PropTypes.bool,
      through: PropTypes.bool,
      throughList: PropTypes.array,
      selectorList: PropTypes.array,
      isRedirect: PropTypes.bool,
      isHasNewFilter: PropTypes.bool,
      redirectRelation: PropTypes.object,     //2018.9.6新增跳转关系字段传入
      //linkList: PropTypes.array,
      linkStatus: PropTypes.string,
      editable: PropTypes.bool,
      isHidden: PropTypes.bool,
      clearSelect: PropTypes.bool,
      originData: PropTypes.object,
      dataGrid: PropTypes.object,
      id: PropTypes.string,
      currentId: PropTypes.string,
      uuid: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
      scaleRate: PropTypes.number,
      chart_config: PropTypes.array,
      events: PropTypes.object,
      dashboardName: PropTypes.string,
      platform: PropTypes.string,
      link_relative: PropTypes.array,
      resetZoomCenter: PropTypes.string, //区域地图用于设置中心点字段
      userToken: PropTypes.string,
      fetchUserToken: PropTypes.func,
      fetchFieldOptions: PropTypes.func,
      charts: PropTypes.object,
      funcSetup: PropTypes.object,
      isShareView: PropTypes.bool,
      dashboardId: PropTypes.string,
      throughIndex: PropTypes.number,
      layoutMode: PropTypes.string,
      onResizeEchart: PropTypes.func,
      isNotice: PropTypes.bool,
      getReportMetadata: PropTypes.func,
      appTerminal: PropTypes.string
    }

    constructor(props) {
      super(props)
      this.state = {
        layer: props.dataGrid || null
      }

      // 暴露的static 方法
      this.getChart = () => {
        if (this.echart && this.echart.getChart && typeof this.echart.getChart === 'function') {
          return this.echart.getChart()
        }
        return null
      }
    }

    componentDidMount() {
      const { containerHooks } = this.props
      const { layer } = this.state
      if (!layer) {
        this.setState({
          layer: {
            w: this.innerBox.offsetWidth,
            h: this.innerBox.offsetHeight,
            x: 0,
            y: 0,
            z: 0
          }
        })
      }
      if (typeof (containerHooks && containerHooks.componentDidMount) === 'function') {
        containerHooks.componentDidMount()
      }
    }

    componentWillReceiveProps(nextProps) {
      this.setState({
        layer: nextProps.dataGrid || {
          w: this.innerBox.offsetWidth,
          h: this.innerBox.offsetHeight,
          x: 0,
          y: 0,
          z: 0
        }
      })
    }

    render() {
      const {
        appContext,
        chartData,
        dashboardChartData,
        charts,
        originData,
        chart_config,
        designTime,
        scaleRate,
        events,
        through,
        throughList,
        id,
        editable,
        currentId,
        clearSelect,
        uuid,
        dashboardName,
        isHidden,
        platform,
        selectorList,
        isRedirect,
        isHasNewFilter,
        redirectRelation,
        linkStatus,
        resetZoomCenter,
        userToken,
        fetchUserToken,
        fetchFieldOptions,
        funcSetup,
        isShareView,
        dashboardId,
        throughIndex,
        layoutMode,
        onResizeEchart,
        isNotice,
        getReportMetadata,
        viewChartDetail,
        isGlobalFilter,
        inFilterDrawer,
        inTabPortal,
        location,
        childrenCharts,
        addContainerHook,
        appTerminal
      } = this.props
      const { link_relative } = chartData
      const { layer } = this.state
      const tenantCode = Cookies.get('tenant_code') || localStorage.getItem('tenant_code')

      return (
        <div className="graph-inner-box" ref={(node) => { this.innerBox = node }}>
          {layer ? <ChartComponent
            ref={(instance) => { this.echart = instance }}
            appContext={appContext}
            appTerminal={appTerminal}
            // chart更新凭证
            chartUuid={uuid}
            chartId={id}
            clearRelated={clearSelect}
            // 同一数据集正在联动的单图id
            currentRelatedChartId={currentId}
            // 设计状态
            designTime={designTime || editable}
            // 是否允许穿透
            through={through}
            // 穿透图层
            throughList={throughList}
            // 穿透到的层级 2018.11.19 new(为组件内部判断是否到达穿透最后一层提供依据)
            throughIndex={throughIndex}
            data={originData}
            configInList={chart_config}
            config={getCustomFieldConfig(chart_config)}
            layer={layer}
            // 缩放比例（使用的比例）
            scale={scaleRate}
            // 报告名称
            dashboardName={dashboardName}
            // 是否为编辑状态
            editable={editable}
            // 是否因tab组件而隐藏
            isHidden={isHidden}
            // 当前展示的平台类型
            platform={platform}
            // 单图联动列表
            linkList={selectorList}
            // 单图联动状态
            linkStatus={linkStatus}
            // 单图是否设置跳转
            isRedirect={isRedirect}
            // 单图是否设置新筛选
            isHasNewFilter={isHasNewFilter}
            // 单图跳转关联
            redirectRelation={redirectRelation}
            // 单图联动数据
            linkRelative={link_relative}
            // 在穿透时用于定位城市中心点
            resetZoomCenter={resetZoomCenter}
            // iframe使用的token
            userToken={userToken}
            // iframe组件需要使用的API
            fetchUserToken={fetchUserToken}
            // 单图信息
            chartData={charts}
            // 树形组件使用
            fetchFieldOptions={fetchFieldOptions}
            // dashboard_chart/chart/data数据
            dashboardChartData={dashboardChartData}
            funcSetup={funcSetup}
            tenantCode={tenantCode}
            isShareView={isShareView}
            dashboardId={dashboardId}
            layoutMode={layoutMode}
            // 在没有数据时是否显示组件内的效果
            isNotice={isNotice}
            events={
              {
                // 设计时修改数据集默认值（用于需要设置默认值的筛选器）
                onChangeDatasetDefaultValue: (defaultValue, type, conditions) => events && events.onChangeDatasetDefaultValue && events.onChangeDatasetDefaultValue(defaultValue, id, type, conditions),
                // 筛选过滤(筛选器)
                onFilterChange: (conditions, chartId, type, dataList, isSubmit, dt, isSpread) => events && events.onFilterChange && events.onFilterChange(conditions, chartId, type, dataList, isSubmit, dt, isSpread),
                // 单图联动
                onRelateChart: events && events.onChartChange,
                // 单图跳转 
                onRedirect: events && events.onRedirect,
                onHDRedirect: events && events.onHDRedirect,
                onHDResizeLayout: events && events.onHDResizeLayout,
                // 单图数据重新请求接口
                onRefreshChart: (params, order, callback) => events && events.onFreshData(id, params, order, callback),
                // 获取单图数据, 不更新状态
                onFetchData: (callback, options) => events && events.onFreshDataSilent(callback, options),
                // 穿透查询
                onPenetrateQuery: events && events.onThrough,
                // tab过滤
                onChangeTab: params => events && events.onChangeTab && events.onChangeTab(params),
                // 获取报告弹层URL
                onGetReportLayerUrl: (href, url, redirect_window_config) => events && events.onGetReportLayerUrl && events.onGetReportLayerUrl(href, url, redirect_window_config),
                // 单图配置保存
                updateConfig: (config, chartId) => events && events.onConfigChange(config, chartId),
                updateChartMetadata: chart => events && events.onChartMetadataChange(chart),
                // grid tab layout change
                onLayoutChange: events && events.onLayoutChange,
                // grid layout change
                onGridLayoutChange: events && events.onGridLayoutChange,
                // 用于 grid tab resize 时更新单图的尺寸
                onResizeEchart,
                // 联动, 跳转, 穿透 通用事件 handler
                onDispatchAction: events && events.onDispatchAction,
                onUpdateChartDecorator: events && events.onUpdateChartDecorator,
                //传输事件通用方法（移动端明细页使用）
                onTransferEvent: (events && events.onTransferEvent) || function () { },
                onImageViewer: (events && events.onImageViewer)
              }
            }
            getReportMetadata={getReportMetadata}
            detailMode={viewChartDetail}
            isGlobalFilter={isGlobalFilter}
            inFilterDrawer={inFilterDrawer}
            inTabPortal={inTabPortal}
            location={location}
            /* 容器单图的子单图 */
            childrenCharts={childrenCharts}
            /* 用于容器组件添加生命周期钩子 */
            addContainerHook={addContainerHook}
            {...chartsdkprops}
          /> : null}
        </div>
      )
    }
  }
}

export {
  Utils,
  Constants,
  BaseComponents,
  PropComponents,
  Connect
}
